import { createRoot } from 'react-dom/client';
import './core/i18n/i18n';
import App from './App';

// E2E auth bypass — Playwright's `loginAs` fixture sets a dev persona through
// this hook. It used to be installed by `firebase.ts`, but since the REST
// cutover that module is only pulled in by the one residual SDK write-site, so
// it no longer runs at startup and every loginAs-based spec timed out waiting
// for the hook. Installing it at bootstrap is the only place all specs share.
// Gated on the emulator flag, so it is tree-shaken out of production builds.
if (import.meta.env.VITE_USE_EMULATORS === 'true') {
  import('./core/dev/devToken').then(({ setPersona }) => {
    (window as unknown as Record<string, unknown>).__e2eSetPersona = setPersona;
  });
}

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW registration failed — app still works without it
    });
  });
}

// StrictMode intentionally disabled: its double-invoke of effects + the app's
// 34+ concurrent onSnapshot subscriptions trigger Firestore internal assertion
// errors (ca9) in dev, poisoning the async queue permanently and leaving every
// page stuck in loading state. This is a dev-only issue — production builds
// never double-invoke effects. Re-enable once subscriptions are centralised in
// a shared context (single listener per collection).
createRoot(document.getElementById('root')!).render(<App />);
